import { Shield, Lock, Users, EyeOff } from 'lucide-react';

const POINTS = [
  {
    icon: Users,
    title: 'Nothing shows up unless 5+ people share it',
    body: 'No theme, sentiment, or quote ever appears in an admin report until at least 5 people have contributed. Full stop.',
  },
  {
    icon: EyeOff,
    title: 'Admins never see your raw words',
    body: 'Your messages to Charles never appear in any admin view. The database itself blocks anyone from even adding that column to a report table.',
  },
  {
    icon: Lock,
    title: 'Your identity is hashed per organization',
    body: 'Your user ID is hashed with an organization-only salt. No one outside your org \u2014 not even other orgs \u2014 can correlate your pulses or messages back to you.',
  },
  {
    icon: Shield,
    title: 'You can erase anything, any time',
    body: 'One tap on any pulse or conversation removes it permanently. The erasure itself is logged so we can prove it happened.',
  },
];

export function TrustCharter() {
  return (
    <div className="space-y-4">
      {POINTS.map((p) => (
        <div key={p.title} className="flex gap-3">
          <div className="shrink-0 h-9 w-9 rounded-md bg-primary/10 text-primary flex items-center justify-center">
            <p.icon className="h-4 w-4" />
          </div>
          <div>
            <h3 className="text-sm font-medium leading-snug">{p.title}</h3>
            <p className="text-sm text-muted-foreground mt-0.5">{p.body}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
